import { Episode, EpisodeCompoundId } from '../models/podcasts';
import log from './debug';

// Used for SSR
class MockAudioPlayer {
  constructor() {
    log('Using SSR-only Audio Player ');
  }

  acknowledgeAdSkipsUpTo(_timestampMs: number) {}

  acknowledgeUsageData(_payload: {
    secondsListened?: Record<EpisodeCompoundId, number>;
    episodeCompletions?: Record<EpisodeCompoundId, number>;
  }) {}

  updateUpcomingEpisodes(_episodes: [EpisodeCompoundId, number][]) {}

  loadNewEpisode(episode: Episode, seek: number, playSkipAdSound: boolean) {}

  reset() {}

  play() {}

  pause() {}

  seekTo(seconds: number, playSkipAdSound: boolean) {}

  updateSeek() {
    return Promise.resolve();
  }
  playFailToSkipAdSound() {}

  updatePlaybackRate() {}

  //
  // Downloading audio
  //

  downloadAudioFile(episode: Episode) {}
  deleteAudioFile(episode: Episode) {}
  checkDownloadedFiles() {}
}

export default MockAudioPlayer;
